import { updateLocale } from '@americanexpress/one-app-ducks';

export const supportedLocales = (market = '') => {
  switch (market.toLowerCase()) {
    case 'en-us':
      return 'en-US';
    case 'en-in':
      return 'en-IN';
    case 'ja-jp':
      return 'ja-JP';
    case 'es-mx':
      return 'es-MX';
    case 'en-gb':
      return 'en-GB';
    case 'en-au':
      return 'en-AU';
    case 'en-hk':
      return 'en-HK';
    case 'zh-hk':
      return 'zh-HK';
    case 'nb-no':
      return 'nb-NO';
    case 'en-ca':
      return 'en-CA';
    case 'fr-ca':
      return 'fr-CA';
    case 'fr-fr':
      return 'fr-FR';
    case 'de-de':
      return 'de-DE';
    case 'it-it':
      return 'it-IT';
    default:
      return null;
  }
};

const configLocale = (store) => {
  const { dispatch } = store;
  return (nextState, replace, callback) => {
    const [, currentLocale] = nextState.location.pathname.split('/');
    const newLocale = supportedLocales(currentLocale);
    if (newLocale) {
      dispatch(updateLocale(newLocale));
    }
    return callback();
  };
};
export default configLocale;
